export const staticRouter = [
  // 静态路由写法示例
  // {
  //   path: '/staticMenu',
  //   name: '',
  //   meta: {
  //     title: '静态目录',
  //     id: '2',
  //     code: 'sys',
  //     show: true,
  //     resourceOrder: 4,
  //     //icon: 'SettingOutlined',
  //     icon: '',
  //     menuType: 'MENU',
  //     hidden: 0,
  //   },
  //   children: [
  //     {
  //       path: '/layout/staticMenu/test1',
  //       name: 'test1',
  //       component: () =>
  //         import(/* webpackChunkName: "login" */ '@/views/systemManage/postManage/index.vue'),
  //       //       meta: {,
  //       meta: {
  //         title: '静态测试菜单1',
  //         id: '7',
  //         resourceOrder: 1,
  //         icon: null,
  //         menuType: 'NAVIGATOR',
  //         hidden: 0,
  //         keepAlive: true,
  //       },
  //     },
  //   ],
  // },
  // {
  //   path: '/talentManage/talent/add',
  //   name: 'TalentAdd',
  //   component: () => import(/* webpackChunkName: "login" */ '@/views/talentManage/talent/add.vue'),
  //   meta: {
  //     title: '人才详情',
  //     id: '7',
  //     resourceOrder: 1,
  //     icon: null,
  //     menuType: 'Menu',
  //     hidden: 0,
  //   },
  // },
  {
      path: '/layout/smsManage/smsPushRecord/:smsTaskId?',
      name: 'smsPushRecord',
      meta: {
          title: '短信推送记录管理',
          hidden: 1,
      },
      component: () => import('@/views/smsManage/smsPushRecord/index.vue')
  }
];
